var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMoreVeritcal = function SvgMoreVeritcal(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00065 4.83333C9.00065 5.29357 8.62755 5.66667 8.16732 5.66667C7.70708 5.66667 7.33398 5.29357 7.33398 4.83333C7.33398 4.3731 7.70708 4 8.16732 4C8.62755 4 9.00065 4.3731 9.00065 4.83333ZM9.00065 8.16667C9.00065 8.6269 8.62755 9 8.16732 9C7.70708 9 7.33398 8.6269 7.33398 8.16667C7.33398 7.70643 7.70708 7.33333 8.16732 7.33333C8.62755 7.33333 9.00065 7.70643 9.00065 8.16667ZM8.16732 12.3333C8.62755 12.3333 9.00065 11.9602 9.00065 11.5C9.00065 11.0398 8.62755 10.6667 8.16732 10.6667C7.70708 10.6667 7.33398 11.0398 7.33398 11.5C7.33398 11.9602 7.70708 12.3333 8.16732 12.3333Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMoreVeritcal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "more-veritcal.ca340166ad7a12a32383c42a3896206a.svg";